import React from "react";
import Card from "../../ui/Card";
import Skeleton from "../../ui/Skeleton";

const RealTimeDashboardSkeleton: React.FC = () => {
  return (
    <div className="space-y-2 animate-pulse">
      {/* Control Header — mesma geometria da barra de título de página real
          (rounded-2xl, sem box de ícone, sem borda inferior). */}
      <div className="flex items-center justify-between gap-3 min-h-[52px] bg-white/70 border border-purple-200 rounded-2xl px-4 sm:px-5 py-2.5 shadow-xs">
        <div className="flex items-center gap-2">
          <Skeleton
            variant="rectangular"
            width={20}
            height={20}
            className="rounded-sm"
          />
          <div>
            <Skeleton
              variant="text"
              width={140}
              height={16}
              className="mb-1.5"
            />
            <Skeleton variant="text" width={220} height={12} />
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Skeleton
            variant="rectangular"
            width={90}
            height={30}
            className="rounded-lg"
          />
          <Skeleton
            variant="rectangular"
            width={32}
            height={32}
            className="rounded-lg"
          />
        </div>
      </div>

      {/* Core Metrics Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="relative overflow-hidden bg-white rounded-xl border border-purple-200 p-4"
          >
            <Skeleton
              variant="rectangular"
              width="100%"
              height={3}
              className="absolute top-0 left-0 rounded-none"
            />
            <div className="flex items-start justify-between pt-0.5">
              <div className="space-y-1.5">
                <Skeleton variant="text" width={60} height={10} />
                <Skeleton variant="text" width={50} height={24} />
              </div>
              <Skeleton
                variant="rectangular"
                width={36}
                height={36}
                className="rounded-lg"
              />
            </div>
          </div>
        ))}
      </div>

      {/* Behavioral Insights */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
        <Card className="p-3 border-purple-200">
          <div className="flex items-center gap-3 mb-3">
            <Skeleton
              variant="rectangular"
              width={20}
              height={20}
              className="rounded-sm"
            />
            <Skeleton variant="text" width={160} height={16} />
          </div>
          <div className="grid grid-cols-2 gap-2">
            {[1, 2, 3, 4].map((j) => (
              <Skeleton
                key={j}
                variant="rectangular"
                width="100%"
                height={64}
                className="rounded-lg"
              />
            ))}
          </div>
        </Card>
        <Card className="p-3 border-purple-200">
          <div className="flex items-center gap-3 mb-3">
            <Skeleton
              variant="rectangular"
              width={20}
              height={20}
              className="rounded-sm"
            />
            <Skeleton variant="text" width={200} height={16} />
          </div>
          <div className="space-y-3">
            {[1, 2, 3, 4, 5].map((j) => (
              <div key={j} className="flex items-center gap-4">
                <Skeleton variant="text" width={40} height={20} />
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={8}
                  className="rounded-full"
                />
                <Skeleton variant="text" width={30} height={12} />
              </div>
            ))}
          </div>
        </Card>
      </div>

      {/* Distributions and Spotlight */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-2">
        <Card className="p-3 border-purple-200 lg:col-span-2">
          <div className="flex items-center gap-3 mb-3">
            <Skeleton
              variant="rectangular"
              width={20}
              height={20}
              className="rounded-sm"
            />
            <Skeleton variant="text" width={200} height={16} />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            {[1, 2, 3, 4].map((j) => (
              <Skeleton
                key={j}
                variant="rectangular"
                width="100%"
                height={44}
                className="rounded-lg"
              />
            ))}
          </div>
        </Card>
        <Card className="p-3 border-purple-200">
          <div className="flex items-center gap-3 mb-3">
            <Skeleton
              variant="rectangular"
              width={20}
              height={20}
              className="rounded-sm"
            />
            <Skeleton variant="text" width={110} height={16} />
          </div>
          <Skeleton variant="text" width="100%" height={40} className="mb-3" />
          <Skeleton
            variant="rectangular"
            width="100%"
            height={44}
            className="rounded-lg"
          />
        </Card>
      </div>
    </div>
  );
};

export default RealTimeDashboardSkeleton;
